<mat-form-field>
  <mat-label>Deal</mat-label>
  <input
    type="text"
    placeholder="Deal name..."
    aria-label="Deal search"
    matInput
    [formControl]="control"
    [matAutocomplete]="auto" />
  @if (
    !control.disabled &&
    control.value &&
    control.value !== '' &&
    !(dealSearch.loading$ | async)
    ) {
    <button
      mat-icon-button
      matSuffix
      color="warn"
      matTooltip="Clear selection"
      (click)="control.setValue('')">
      <mat-icon>close</mat-icon>
    </button>
  }
  @if (!control.disabled && (dealSearch.loading$ | async)) {
    <mat-spinner
      mode="indeterminate"
      matSuffix
      diameter="16"
    ></mat-spinner>
  }
  <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn">
    @for (option of dealSearch.options$ | async; track option) {
      <mat-option
        [value]="option">
        {{ option.name }}
      </mat-option>
    }
  </mat-autocomplete>
  <mat-error>Deal is required!</mat-error>
</mat-form-field>
